import * as React from "react";
import Popover from "@mui/material/Popover";
import Button from "@mui/material/Button";
import { FIlterIcon } from "../../assets/Icon/headerCicon";

interface SearchDropdownProps {
  children: React.ReactNode;
  onClose?: () => void;
  selectedCompany?: any;
  isFilterApplied?: boolean;
  startDate?: any;
}

const SearchDropdown = React.forwardRef<any, SearchDropdownProps>(
  ({ children, onClose, selectedCompany, isFilterApplied, startDate }, ref) => {
    const [anchorEl, setAnchorEl] = React.useState<HTMLButtonElement | null>(
      null
    );

    const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
      setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
      setAnchorEl(null);
      onClose?.();
    };

    // Expose close method to parent component
    React.useImperativeHandle(ref, () => ({
      close: handleClose,
    }));

    const open = Boolean(anchorEl);
    const id = open ? "simple-popover" : undefined;

    return (
      <div style={{ position: "relative" }}>
        {}
        <Button
          aria-describedby={id}
          variant="outlined"
          onClick={handleClick}
          startIcon={<FIlterIcon fill="#2977CC" />}
        >
          Filter
        </Button>
        {(selectedCompany || startDate) && isFilterApplied && (
          <div
            style={{
              height: "5px",
              width: "6px",
              backgroundColor: "red",
              borderRadius: "100%",
              position: "absolute",
              top: "7px",
              left: "9px",
            }}
          ></div>
        )}
        <Popover
          id={id}
          open={open}
          anchorEl={anchorEl}
          onClose={handleClose}
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "right",
          }}
          sx={{
            left: "-40px",
            borderRadius: "10px",
            "& .MuiPopover-paper": {
              // width: "300px",
              marginTop: "10px",
              boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.2) !important",
            },
          }}
        >
          {/* <Typography variant="h4">Search</Typography> */}

          {children}
        </Popover>
      </div>
    );
  }
);

SearchDropdown.displayName = "SearchDropdown";

export default SearchDropdown;
